document.addEventListener("DOMContentLoaded", () => {
  const dropdowns = document.querySelectorAll(".bls__color-dropdown");

    function closeAll(except = null) {
      dropdowns.forEach((dd) => {
        if (dd === except) return;
        const btn = dd.querySelector('.bls__color-dropdown-action');
        const list = dd.querySelector('[role="listbox"]');
        btn.setAttribute('aria-expanded', 'false');
        dd.classList.remove('isClicked');
        list.hidden = true;
        list.setAttribute('tabindex', '-1');
      });
    }

  dropdowns.forEach((dropdown) => {
    const btn = dropdown.querySelector(".bls__color-dropdown-action");
    const list = dropdown.querySelector('[role="listbox"]');
    const options = Array.from(list.querySelectorAll('[role="option"]'));

    btn.setAttribute("aria-expanded", "false");
    list.hidden = true;
    list.setAttribute("tabindex", "-1");

    let activeIndex = 0;

    function setActive(index) {
      options.forEach((opt, i) => {
        opt.classList.toggle("active", i === index);
      });
      activeIndex = index;
      console.log("options[activeIndex].id", options[activeIndex].id);
      list.setAttribute("aria-activedescendant", options[activeIndex].id);
      options[index].scrollIntoView({ block: "nearest" });
    }

    function updateAriaSelected() {
      setTimeout(() => {
        options.forEach((opt) => {
          const isActive = opt.classList.contains("active");
          opt.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      }, 100);
    }

    btn.addEventListener("click", () => {
      const expanded = btn.getAttribute("aria-expanded") === "true";
      if (expanded) {
        btn.setAttribute("aria-expanded", "false");
        dropdown.classList.remove("isClicked");
        list.hidden = true;
        list.setAttribute("tabindex", "-1");
      } else {
        closeAll(dropdown);
        btn.setAttribute("aria-expanded", "true");
        dropdown.classList.add("isClicked");
        list.hidden = false;
        list.setAttribute("tabindex", "0");
        list.focus();
      }
    });

    btn.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        const expanded = btn.getAttribute("aria-expanded") === "true";
        if (!expanded) {
          closeAll(dropdown);
          btn.setAttribute("aria-expanded", "true");
          dropdown.classList.add("isClicked");
          list.hidden = false;
          list.setAttribute("tabindex", "0");
          list.focus();
        } else {
          btn.setAttribute("aria-expanded", "false");
          dropdown.classList.remove("isClicked");
          list.hidden = true;
          list.setAttribute("tabindex", "-1");
        }
      }
    });

    list.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActive((activeIndex + 1) % options.length);
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        setActive((activeIndex - 1 + options.length) % options.length);
      }

      if (e.key === "Enter") {
        e.preventDefault();
        const selected = options[activeIndex];
        if (selected) {
          selected.click();
        }
      }

      if (e.key === "Escape") {
        e.preventDefault();
        btn.setAttribute("aria-expanded", "false");
        dropdown.classList.remove("isClicked");
        list.hidden = true;
        list.setAttribute("tabindex", "-1");
        btn.focus();
      }
    });

    options.forEach((opt, i) => {
      opt.addEventListener("click", () => {
        options.forEach((o) => o.classList.remove("active"));
        opt.classList.add("active");
        updateAriaSelected();

        if (opt.id) {
          list.setAttribute("aria-activedescendant", opt.id);
        }

        btn.setAttribute("aria-expanded", "false");
        dropdown.classList.remove("isClicked");
        list.hidden = true;
        list.setAttribute("tabindex", "-1");
        btn.focus();
      });
    });
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".bls__color-dropdown")) {
      closeAll();
    }
  });
});
